import EwaybillType from "@/enum/EwaybillType";

const EwaybillTypeNameMap = {
    [EwaybillType.TAOBAO_CAINIAO]: "淘宝菜鸟电子面单",

    [EwaybillType.TAOBAO_CAINIAO_AUTH]: "淘宝菜鸟电子面单授权",

    [EwaybillType.TAOBAO_CAINIAO_AUTH_SHARE]: "淘宝菜鸟电子面单(共享)",

    [EwaybillType.CAINIAO]: "菜鸟电子面单",

    [EwaybillType.JD]: "京东无界电子面单",

    [EwaybillType.JD_SHARE]: "京东无界电子面单(共享)",

    [EwaybillType.JD_AUTH]: "京东无界站外电子面单授权",

    [EwaybillType.JDL]: "京东物流云",

    [EwaybillType.PDD]: "拼多多店铺电子面单",

    [EwaybillType.PDD_SHARE]: "拼多多店铺电子面单(共享)",

    [EwaybillType.PDD_AUTH]: "拼多多站外电子面单",

    [EwaybillType.PDD_AUTH_SHARE]: "拼多多站外电子面单(共享)",

    [EwaybillType.OFFICIAL]: "快递官方电子面单",

    [EwaybillType.OFFICIAL_SHARE]: "快递官方电子面单(共享)",

    [EwaybillType.JINRITEMAI]: "抖音电子面单",

    [EwaybillType.JINRITEMAI_AUTH]: "抖音站外电子面单",

    [EwaybillType.JINRITEMAI_AUTH_SHARE]: "抖音站外电子面单(共享)",

    [EwaybillType.JINRITEMAI_SHARE]: "抖音电子面单(共享)",

    [EwaybillType.JINRITEMAI_SHOP_AUTH]: "抖音电子面单店铺授权",

    [EwaybillType.JINRITEMAI_IOP]: "抖音代发电子面单",

    [EwaybillType.JINRITEMAI_SUPPLIER]: "抖音供货商电子面单",

    [EwaybillType.JINRITEMAI_ONLINE_SHIP]: "抖音在线寄件",

    [EwaybillType.CAINIAO_GUOGUO]: "菜鸟裹裹",

    [EwaybillType.KWAISHOP]: "快手电子面单",

    [EwaybillType.KWAISHOP_SHARE]: "快手电子面单(共享)",

    [EwaybillType.KWAISHOP_SHOP_AUTH]: "快手电子面单店铺授权",

    [EwaybillType.KWAISHOP_DROPSHIP]: "快手代发电子面单",

    [EwaybillType.WEBUY]: "鲸灵电子面单",

    [EwaybillType.CHANNEL_SHOP]: "微信小店电子面单",

    [EwaybillType.CHANNEL_SHOP_SHARE]: "微信小店电子面单(共享)",

    [EwaybillType.CHANNEL_SHOP_AUTH]: "微信小店电子面单授权",

    [EwaybillType.CHANNEL_SHOP_DROPSHIP]: "微信小店供货商代发电子面单",

    [EwaybillType.XIAOHONGSHU]: "小红书电子面单",

    [EwaybillType.XIAOHONGSHU_AUTH]: "小红书站外电子面单",

    [EwaybillType.XIAOHONGSHU_SHARE]: "小红书电子面单(共享)",

    [EwaybillType.AIKUCUN]: "爱库存电子面单",
};

export default EwaybillTypeNameMap;
